"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRow = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("..");
const classFunctions_1 = require("../../../utils/classFunctions");
const cell_1 = require("./cell");
const TableRow = (props) => {
    var _a;
    const { row, rowIndex, rowCount, selectionProps, tableRef, tableModificators, } = props;
    const classNames = (0, classFunctions_1.getClassNames)(`${__1.className}__row`, (_a = tableModificators === null || tableModificators === void 0 ? void 0 : tableModificators.row) === null || _a === void 0 ? void 0 : _a.call(tableModificators, row));
    return (react_1.default.createElement("tr", { ...row.getRowProps(), className: classNames }, row.cells.map((cell, i) => {
        const cellProps = {
            cell,
            rowIndex,
            rowCount,
            selectionProps,
            tableRef,
            tableModificators,
        };
        return (react_1.default.createElement(cell_1.TableCell, { ...cellProps, key: i }));
    })));
};
exports.TableRow = TableRow;
//# sourceMappingURL=row.js.map